<!-- store.getters.getHeaderInfo.sugang.isBanner 배너 노출 설정값 -->
<template>
  <article
    class="bottom-banner-wrapper"
    v-show="store.getters?.getHeaderInfo?.sugang?.isBanner == 'Y'"
  >
    <div class="bg-top" :class="bgcolor"></div>
    <div class="bg-bottom" :class="themecss ? themecss : ''"></div>
    <div class="bg-banner" :class="themecss ? themecss : ''"></div>
  </article>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
export default {
  props: {
    //banner-white
    //banner-tutor
    //banner-darkgray
    imgname: {
      type: String,
      required: false,
      default: "banner-gray",
    },
    themecss: {
      type: String,
      required: false,
      default: "",
    },
    bgcolor: {
      type: String,
      required: false,
      default: "",
    },
  },

  setup(props) {
    const store = useStore();
    const imageName = ref("");

    onMounted(() => {
      setBgBanner();
    });

    const setBgBanner = () => {
      const ele = document.querySelector(".bg-banner");

      if (ele) {
        if (props.imgname) {
          ele.style.background = `url(${require(`@/assets/imgs/common/${props.imgname}.png`)}) no-repeat center / contain`;
        }
      }
    };

    watch(
      () => props.imgname,
      (cur) => {
        if (cur) {
          setBgBanner();
        }
      }
    );

    return {
      imageName,
      store,
    };
  },
};
</script>

<style lang="scss" scoped>
.bottom-banner-wrapper {
  position: relative;
  overflow: hidden;
  height: 191px;

  .bg-top {
    width: 100%;
    height: 36px;
    background-color: #f6f7f8;

    &.white {
      background-color: $white;
    }

    &.darkgray {
      background-color: $gray-e6e9ec;
    }
  }

  .bg-bottom {
    width: 100%;
    height: 155px;
    background-color: #5159b8;

    &.aitutor {
      background: linear-gradient(#f6934f, #fa435a);
    }
  }

  .bg-banner {
    width: 1920px;
    height: 191px;
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    flex: none;

    &.aitutor {
      height: 188px;
    }
  }
}
</style>
